export default "__VITE_ASSET__RX_9eL9y__"